import { CSpinner } from '@coreui/react';
import React from 'react';

const BaseSpinner = React.memo(({ ...rest }) => {
  return <CSpinner {...rest} />;
});

export default BaseSpinner;
